//getUserWoAssTask
import _axios from '../../util/axios/AxiosConfig'

export function getSuppliers(key){
    return _axios({
      url: `/api/ERPCommon/getSuppliers?key=${key}`,
      method: 'get'
    })
}

export function getCustomers(key){
  return _axios({
    url: `/api/ERPCommon/getCustomers?key=${key}`,
    method: 'get'
  })
}

export function getStores(key){
  return _axios({
    url: `/api/ERPCommon/getStores?key=${key}`,
    method: 'get'
  })
}


export function checkStoreProp(id1,id2){
  return _axios({
      url: `/api/ERPCommon/isStoreAllocateValid?id1=${id1}&id2=${id2}`,
      method: 'post'
  })
}

export function isProductEnableBatch(productId){
  return _axios({
      url: `/api/ERPCommon/isProductEnableBatch?productId=${productId}`,
      method: 'post'
  })
}